import React from 'react'

const SocialLinkedIcon = (
  <>
    <path
      d="M37.0404 0H2.95079C1.32319 0 0.000488281 1.29123 0.000488281 2.88411V37.1137C0.000488281 38.7066 1.32319 40 2.95079 40H37.0404C38.6713 40 39.9994 38.7066 39.9994 37.1137V2.88411C39.9994 1.29123 38.6713 0 37.0404 0Z"
      fill="#007BB5"
    />
    <path
      d="M5.92696 14.9958H11.8655V34.0843H5.92696V14.9958ZM8.89789 5.50684C10.7957 5.50684 12.3364 7.04818 12.3364 8.94706C12.3364 10.8465 10.7957 12.3878 8.89789 12.3878C6.99251 12.3878 5.45605 10.8465 5.45605 8.94706C5.45605 7.04818 6.9925 5.50684 8.89789 5.50684Z"
      fill="white"
    />
    <path
      d="M15.5874 14.9961H21.2743V17.6057H21.3556C22.1466 16.105 24.0824 14.5225 26.9687 14.5225C32.9756 14.5225 34.0857 18.4749 34.0857 23.6159V34.0847H28.1536V24.8019C28.1536 22.5883 28.1156 19.7406 25.071 19.7406C21.984 19.7406 21.513 22.1532 21.513 24.6435V34.0847H15.5874V14.9961Z"
      fill="white"
    />
  </>
)

export default SocialLinkedIcon
